
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 6853 973","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"486.488","cy":"486.488","r":"486.488","fill":"#d00130"}}),_c('circle',{attrs:{"cx":"1662.45","cy":"486.488","r":"486.488","fill":"#d00130"}}),_c('circle',{attrs:{"cx":"2838.41","cy":"486.488","r":"486.488","fill":"#d00130"}}),_c('path',{attrs:{"d":"M2826.41 536.738c26-39 45-71.25 57-96.75s18-48.75 18-69.75c0-26-7.375-46.625-22.125-61.875s-34.625-22.875-59.625-22.875c-46.5 0-89 19.75-127.5 59.25l-9-75c19-15 40.75-27.25 65.25-36.75s50.75-14.25 78.75-14.25c46.5 0 82.5 13.5 108 40.5s38.25 61.5 38.25 103.5c0 33-6.375 64.25-19.125 93.75s-34.375 67.25-64.875 113.25l-79.5 120h183.75v64.5h-310.5l143.25-217.5z","fill":"#fff","fill-rule":"nonzero"}}),_c('g',{attrs:{"fill":"#0b0c0f"}},[_c('circle',{attrs:{"cx":"4014.38","cy":"486.488","r":"486.488"}}),_c('circle',{attrs:{"cx":"5190.34","cy":"486.488","r":"486.488"}}),_c('circle',{attrs:{"cx":"6366.3","cy":"486.488","r":"486.488"}})])])
          )
        }
      }
    